import { ServiceLocation } from '@features/wizard/types/types.ts';
import { ServiceLocationsFormModel } from '@features/wizard/utils/service-locations-form.model.ts';
import { TextField } from '@mui/material';
import { DateTime } from 'luxon';
import { Controller, useFormContext } from 'react-hook-form';

type RequestedConnectDateInputProps = {
  serviceLocation: ServiceLocation;
};

/**
 * Date input that handles setting the min and max range allowed for service connect.
 */
export const RequestedConnectDateInput = ({ serviceLocation }: RequestedConnectDateInputProps) => {
  const now = DateTime.now();
  const tomorrow = now.plus({ days: 1 });
  const maximumDate = now.plus({ days: 60 });

  const form = useFormContext<ServiceLocationsFormModel>();

  return (
    <Controller
      shouldUnregister
      control={form.control}
      name="requestedConnectDate"
      defaultValue={serviceLocation.requestedConnectDate ?? ''}
      rules={{
        required: true
      }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          label="Requested Connect Date"
          {...field}
          type="date"
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: tomorrow.toISODate(),
            max: maximumDate.toISODate()
          }}
          error={!!error}
          helperText={error?.message ?? 'Connections may not be available on weekends or holidays. If your requested connect date is unavailable, we will select the next business day.'}
        />
      )}
    />
  );
};
